import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
} from '@mui/material';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import ActivitiesStyles from './ActivitiesStyles';

const ActivitiesCircularGraph = (tab, data) => {

  console.log("tab ", tab);
  console.log("data ", data);

  const classes = ActivitiesStyles();
  let maxDriving;
  let maxWorking;
  let maxPause;
  let maxOther;

  let currentWork = 0;
  let currentDriving = 0;
  let currentPause = 0;
  let currentOther = 0;

  let drivingHours = '0h 0m 0s'; // 2 days, 0 hours, 10 minutes
  let workingHours = '0h 0m 0s'; // 2 days, 0 hours, 10 minutes
  let pauseHours = '0h 0m 0s'; // 2 days, 0 hours, 10 minutes
  let otherHours = '0h 0m 0s'; // 2 days, 0 hours, 10 minutes
  console.log("current driving: ", currentDriving);

  const maxTimers = data
  ? data.work + data.driving + data.pause + data.other
  : 0;

    // Function to calculate percentage
    const calculatePercentage = (value) => {
      if (!data || maxTimers === 0) {
        return 0; // No total counts or all counters are zero
      }
      if (value === 0) {
        return 100; // Total counts exist but value is zero
      }
      return (value * 100) / maxTimers;
    };
  
  if(tab==1){
    maxDriving = 8*60*5;
    maxPause = 1*60*5;
    maxOther = 8*60*5;
    maxWorking = 8*60*5;
  }
  if(tab==2){
    maxDriving = 8*60*getDaysInCurrentMonth();
    maxPause = 1*60*getDaysInCurrentMonth();
    maxOther = 8*60*getDaysInCurrentMonth();
    maxWorking = 8*60*getDaysInCurrentMonth();
  }
  if(tab==3){
    maxDriving = 8*60*getDaysSinceStartOfYear();
    maxPause = 1*60*getDaysSinceStartOfYear();
    maxOther = 8*60*getDaysSinceStartOfYear();
    maxWorking = 8*60*getDaysSinceStartOfYear();
  }

  if (data!=0){
     currentWork = calculatePercentage(data.work);
     currentDriving = calculatePercentage(data.driving);
     currentPause = calculatePercentage(data.pause);
     currentOther = calculatePercentage(data.other);
     drivingHours = convertMinutesToTimeString(data.driving); // 2 days, 0 hours, 10 minutes
    workingHours = convertMinutesToTimeString(data.work); // 2 days, 0 hours, 10 minutes
    pauseHours = convertMinutesToTimeString(data.pause); // 2 days, 0 hours, 10 minutes
    otherHours = convertMinutesToTimeString(data.other); // 2 days, 0 hours, 10 minutes
  }

    return (
    <Container>
      <Box sx={{display:'block', height:'170px'}}>
        <div className={classes.graphDivider}>
        <div className={classes.graphContainer}>
        {
          //Driving GRAPH
        }
        <CircularProgress
            variant="determinate"
            className={classes.grayGraph}
            size={165}
            thickness={2}
            value={100}
          />
          <CircularProgress
            variant="determinate"
            
            className= {classes.workGraph}
            size={165}
            thickness={2}
            value={currentDriving}
            color="primary"
          />

        {
          //Work GRAPH
        }
        <CircularProgress
          variant="determinate"
          className={classes.grayGraph}
          size={130}
          thickness={2.7}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          className= {classes.pauseGraph}
          size={130}
          thickness={2.7}
          value={currentWork}
          color="primary"
        />

        {
          //REST GRAPH
        }
        <CircularProgress
          variant="determinate"
          className={classes.grayGraph}
          size={95}
          thickness={3.5}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          
          className= {classes.restGraph}
          size={95}
          thickness={3.5}
          value={currentPause}
          color="primary"
        />

  {
          //OTHER GRAPH
        }
        <CircularProgress
          variant="determinate"
          className={classes.grayGraph}
          size={60}
          thickness={5}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          
          className= {classes.otherGraph}
          size={60}
          thickness={5}
          value={currentOther}
          color="primary"
        />
        </div>
        </div>
        <div className={classes.graphDivider}>
          <div className={classes.graphDetails} >
            <List>
              <ListItem id="drivingItem" alignItems="center">
                <Box className={classes.circle} bgcolor='#6179D3'/>
                Condução
              </ListItem>
              <ListItem id="workingItem" alignItems="center">
                <Box className={classes.circle} bgcolor='#ffc465'/>
                Trabalho
              </ListItem>
              <ListItem id="pausingItem" alignItems="center">
                <Box className={classes.circle} bgcolor='#FD7C57'/>
                Descanso
              </ListItem>
              <ListItem id="otherItem" alignItems="center">
                <Box className={classes.circle} bgcolor='#AEA4E3'/>
                Outro
              </ListItem>
            </List>
          </div>
        </div>
      </Box>
      <List className={classes.graphTimers}>
            <ListItem id="drivingTime" alignItems="center">
              <Box className={classes.circle} bgcolor='#6179D3'/>
                {drivingHours}
            </ListItem>
            <ListItem id="workTime" alignItems="center">
              <Box className={classes.circle} bgcolor='#ffc465'/>
                {workingHours}
            </ListItem>
            <ListItem id="pauseTime" alignItems="center">
              <Box className={classes.circle} bgcolor='#FD7C57'/>
                {pauseHours}
            </ListItem>
            <ListItem id="otherTime" alignItems="center">
              <Box className={classes.circle} bgcolor='#AEA4E3'/>
                {otherHours}
            </ListItem>
          </List>
    </Container>
    
  )};

  function convertMinutesToTimeString(totalMinutes) {
    const days = Math.floor(totalMinutes / 1440);   // 1440 minutes in a day
    const hours = Math.floor((totalMinutes % 1440) / 60);   // Remaining hours
    const minutes = totalMinutes % 60;   // Remaining minutes
  
    let result = '';
    if (days > 0) result += `${days} day${days > 1 ? 's' : ''}, `;
    if (hours > 0 || days > 0) result += `${hours} hour${hours > 1 ? 's' : ''}, `;
    result += `${minutes} minute${minutes > 1 ? 's' : ''}`;
  
    return result;
  }

  function getDaysInCurrentMonth() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
  
    // Set date to the next month, day 0 to get the last day of the current month
    const lastDayOfMonth = new Date(year, month + 1, 0);
  
    return lastDayOfMonth.getDate();
  }

  function getDaysSinceStartOfYear() {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);  // January 1st of the current year
  
    // Calculate the difference in milliseconds
    const diffInMillis = now - startOfYear;
  
    // Convert milliseconds to days
    const daysSinceStartOfYear = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
  
    return daysSinceStartOfYear;
  }
  
  // Example usage:
  console.log(`Days since the start of the year: ${getDaysSinceStartOfYear()}`);
  
  
  // Example usage:
  console.log(`Days in the current month: ${getDaysInCurrentMonth()}`);
  

  export default ActivitiesCircularGraph;